module.exports = __webpack_public_path__ + "media/components/Influencers/Oauths/New/StepPage/step4_2-12e5277b97e36052ece6835692e6127d.png";